import React from 'react';
import PropTypes from 'prop-types';
import { calculateBillingDates } from '../../../utils';

/**
 * Reusable component for displaying billing details in pause scenarios
 * Standardizes the billing information text across different pause contexts
 */
const DowngradeBillingDetailsFooter = ({ price = 15, className = '' }) => {
  const { formattedNextBillingDate } = calculateBillingDates();
  return (
    <div className={`billing-details text-muted small ${className}`}>
      <p>
        By switching plans, you'll be billed <strong>${price}/month</strong> starting {formattedNextBillingDate}. Your
        membership will automatically renew each month unless canceled. You can manage or cancel anytime in your Member
        Center.
      </p>
    </div>
  );
};

DowngradeBillingDetailsFooter.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number
};

export default DowngradeBillingDetailsFooter;
